import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';

@Component({
  selector: 'app-hints',
  templateUrl: './hints.component.html',
  styleUrls: ['./hints.component.scss'],
})
export class HintsComponent implements OnInit {
  correct_answer:any;
  explation: any;
  

  constructor(private navParams: NavParams) {
    this.correct_answer = this.navParams.data.ans;
    this.explation = this.navParams.data.exp;
    
   }

  ngOnInit() {}

}
